import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import PageTitle from "../../../components/pageTitle/PageTitle.vue";
import Attachments from "../form/Attachments.vue";
import FormContent from "../form/FormContent.vue";
import FormDetails from "../form/FormDetails.vue";
import providerApiService from "../../../services/api/ProviderApiService";
export default {
  name: "Create.vue",
  components: {
    FormDetails: FormDetails,
    FormContent: FormContent,
    Attachments: Attachments,
    PageTitle: PageTitle
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })),
  methods: {
    submit: function submit() {
      var _this = this;

      /**
       * Get the form data and attachments
       */
      var details = this.$refs["formDetails"].getData();
      var content = this.$refs["formContent"].getData();
      var attachments = this.$refs["formAttachments"].getData();
      /**
       * Send request to server with given data
       */

      this.$vs.loading();
      providerApiService.postCreateOrEditTicket({
        providerId: this.currentProvider.id,
        title: content.title,
        content: content.content,
        department: details.department.id,
        priority: details.priority.id,
        attachments: attachments
      }).then(function () {
        _this.$vs.notify({
          text: "عملیات با موفقیت انجام شد.",
          color: "success",
          position: "bottom-center"
        });

        _this.onClickBack();
      }).finally(function () {
        return _this.$vs.loading.close();
      });
    },
    onClickBack: function onClickBack() {
      this.$router.back();
    }
  }
};